import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import SeoHead from "@/components/base/SeoHead";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import ServicesSection from "./components/ServicesSection";
import TechnologiesSection from "./components/TechnologiesSection";
import AchievementsSection from "./components/AchievementsSection";
import PortfolioSection from "./components/PortfolioSection";
import TestimonialsSection from "./components/TestimonialsSection";
import PricingSection from "./components/PricingSection";
import BlogSection from "./components/BlogSection";
import AwardsSection from "./components/AwardsSection";
import FAQSection from "./components/FAQSection";
import ContactSection from "./components/ContactSection";
import { faqItems } from "./components/FAQSection";

const homepageJsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "BitNinja Technologies — IT Solutions & Digital Innovation",
    "description": "Forward-thinking IT company delivering reliable, scalable, and secure digital solutions for modern businesses worldwide. Web development, mobile apps, cloud, and digital marketing.",
    "url": "https://bitninjatech.com",
    "about": {
      "@type": "Organization",
      "name": "BitNinja Technologies",
      "url": "https://bitninjatech.com"
    }
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqItems.map((item) => ({
      "@type": "Question",
      "name": item.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": item.answer
      }
    }))
  }
];

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <SeoHead
        title="BitNinja Technologies | IT Solutions & Digital Innovation"
        description="BitNinja Technologies delivers cutting-edge IT solutions, web development, mobile apps, cloud services, and digital marketing. Based in Surat, India and California, US. Est. 2025."
        canonicalUrl="https://bitninjatech.com"
        jsonLd={homepageJsonLd}
      />
      <Navbar />
      <main>
        <HeroSection />
        <AboutSection />
        <ServicesSection />
        <TechnologiesSection />
        <AchievementsSection />
        <PortfolioSection />
        <TestimonialsSection />
        <PricingSection />
        <BlogSection />
        <AwardsSection />
        <FAQSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;